import type { VoidFunctionComponent } from 'react';

import { LabeledSelect } from '../../../../../generic';
import type { SelectOption, SetState } from '../../../../../../types';
import type { FormatName } from '../types';

export type FormatSelection = SelectOption<FormatName>;

type FormatSelectProps = {
  format: FormatSelection;
  formats: FormatSelection[];
  setFormat: SetState<FormatSelection>;
};

const FormatSelect: VoidFunctionComponent<FormatSelectProps> = ({ format, formats, setFormat }: FormatSelectProps) => (
  <div className="width-full" data-test-id="report-filters">
    <LabeledSelect
      label="Format"
      value={format}
      options={formats}
      id="report-format"
      onChange={(option: FormatSelection | null) => {
        if (option) {
          setFormat(option);
        }
      }}
    />
  </div>
);

export default FormatSelect;
